import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ArrowRight = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      fillRule="nonzero"
      d="M2.117 14.121h14.66l-4.859 4.86a2.134 2.134 0 0 0 0 2.992 2.13 2.13 0 0 0 2.996 0l8.473-8.473a2.134 2.134 0 0 0 0-2.992l-8.473-8.473a2.097 2.097 0 0 0-1.5-.625c-.535 0-1.07.2-1.496.625a2.134 2.134 0 0 0 0 2.992l4.86 4.86H2.117A2.132 2.132 0 0 0 0 12.004c0 1.156.96 2.117 2.117 2.117Zm0 0"
      fill={color}
    />
  </svg>
));

export default ArrowRight;
